import React from "react";

import styled from "styled-components/macro";
import { mediaQueries } from "../../styles/media.js";

import FullWidthBackground from "../../components/FullWidthBackground";
import { TRUSTPILOT } from "../../constants";

const QuoteLandingPageCopy = ({ pageWidth }) => {
  return (
    <StyledFullWidthBackground pageWidth={pageWidth}>
      <StyledHeading>Get your fixed price in under a minute</StyledHeading>
      <p>
        Rated {TRUSTPILOT.rating} out of 5 on{" "}
        <StyledTrustpilotLink href={TRUSTPILOT.reviewUrl} target="_blank" rel="noopener noreferrer">
          Trustpilot
        </StyledTrustpilotLink>{" "}
        from {TRUSTPILOT.reviewCount} client reviews
      </p>
      <p>Everything’s included: search reports, ID checks and bank transfers. Nothing to pay now.</p>
    </StyledFullWidthBackground>
  );
};

export default QuoteLandingPageCopy;

const StyledFullWidthBackground = styled(FullWidthBackground)`
  ${mediaQueries.md} {
    top: -30px;
  }
`;

// TODO: Update theme to include 'display' heading styles
const StyledHeading = styled.h1`
  max-width: 38rem;
  font-size: 2.25rem;
  line-height: 2.75rem;
  font-weight: var(--juno-font-weight-light);
  margin-top: 1rem;
  margin-bottom: 0.75rem;

  ${mediaQueries.md} {
    font-size: 3.25rem;
    line-height: 4rem;
    margin-bottom: 1rem;
  }
`;

const StyledTrustpilotLink = styled.a`
  /* The global a:link rule outranks a plain class, so the reversed text colour has to be claimed per state */
  &:link,
  &:visited {
    color: inherit;
  }

  /* Only one word is linked on reversed text, so it needs an underline to read as a link */
  text-decoration: underline;
`;
